
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import {
  AngularImageViewerComponent,
  AngularImageViewerModule,
} from '@clarivate/angular-image-viewer';
import { RebateType } from 'src/app/enumeration/rebateType';
import { CreditNotesApiService } from 'src/app/services/credit_notes_service';
import { PriceListApiService } from 'src/app/services/pricelist_service';
import { RebateApiService } from 'src/app/services/rebate_service';
import { SaleSystemApiService } from 'src/app/services/sale_system_service';
import { Refrsh } from 'src/app/utils/refresh';

@Component({
  selector: 'app-image-viewer',
  imports: [RouterModule, AngularImageViewerModule],
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.css'],
})
export class ImageViewerComponent {
  @ViewChild(AngularImageViewerComponent)
  imageViewer!: AngularImageViewerComponent;

  private initialZoomApplied = false;

  src: any = [];
  link: any;
  type: any;
  name: any;
  fileName: any;
  imageIndex = 0;
  rebateType = RebateType.SALES_REBATE;
  data : any
  setting = {
    btnClass: 'default', // The CSS class(es) that will apply to the buttons
    zoomFactor: 0.1, // The amount that the scale will be increased by
    containerBackgroundColor: '#ffffff', // The color to use for the background. This can provided in hex, or rgb(a).
    primaryColor: '', // Color to use for all buttons image.
    wheelZoom: true, // If true, the mouse wheel can be used to zoom in
    allowFullscreen: true, // If true, the fullscreen button will be shown, allowing the user to enter fullscreen mode
    allowKeyboardNavigation: false, // If true, the left / right arrow keys can be used for navigation
    isZoomPersistent: false, // if true, keeps zoom persistent across image exploration
    btnIcons: {
      // The icon classes that will apply to the buttons. By default, font-awesome is used.
      zoomIn: 'fa fa-plus',
      zoomOut: 'fa fa-minus',
      rotateClockwise: 'fa fa-repeat',
      rotateCounterClockwise: 'fa fa-undo',
      next: 'fa fa-arrow-right',
      prev: 'fa fa-arrow-left',
      fullscreen: 'fa fa-arrows-alt',
      reset: 'fas fa-undo',
    },
    btnShow: {
      zoomIn: true,
      zoomOut: true,
      rotateClockwise: true,
      rotateCounterClockwise: false,
      next: true,
      prev: true,
      reset: true,
    },
    customBtns: [
      {
        name: 'reset',
        icon: 'fas fa-undo',
      },
      {
        name: 'print',
        icon: 'fas fa-print',
      },
      {
        name: 'download',
        icon: 'fas fa-download',
      },
    ],
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private refresh: Refrsh,
    private saleSystemService: SaleSystemApiService,
    private creditNotesService: CreditNotesApiService,
    private rebateService: RebateApiService,
    private priceListService: PriceListApiService
  ) { }

  ngOnInit(): void {
    const routeParams = this.route.snapshot.paramMap;
    this.type = String(routeParams.get('type'));
    this.name = String(routeParams.get('imgName'));
    this.fileName = String(routeParams.get('imgFileName'));
    if (this.type === 'SaleSystem') {
      this.getSaleSystemDownloadFile();
    } else if (this.type === 'CreditNote') {
      this.getCreditNotesDownloadFile();
    } else if (this.type === 'Rebate') {
      this.rebateType = RebateType.SALES_REBATE;
      this.getRebateDownloadFile();
    } else if (this.type === 'Premier') {
      this.rebateType = RebateType.PREMIER_POINT;
      this.getRebateDownloadFile();
    } else {
      this.getPriceListDownloadFile();
    }
  }

  getSaleSystemDownloadFile() {
    this.saleSystemService.getDownloadFile(this.name).subscribe({
      next: (response) => {
        this.getPdffile(response);
      },
      error: (e) => {
        if (e) {
          alert(e);
        }
      },
      complete: () => { },
    });
  }

  getCreditNotesDownloadFile() {
    this.creditNotesService.getDownloadFile(this.name).subscribe({
      next: (response) => {
        this.getPdffile(response);
      },
      error: (e) => {
        if (e) {
          alert(e);
        }
      },
      complete: () => { },
    });
  }

  getRebateDownloadFile() {
    this.rebateService.getDownloadFile(this.name, this.rebateType).subscribe({
      next: (response) => {
        this.getPdffile(response);
      },
      error: (e) => {
        if (e) {
          alert(e);
        }
      },
      complete: () => { },
    });
  }

  getPriceListDownloadFile() {
    this.priceListService.getDownloadFile(this.name).subscribe({
      next: (response) => {
        this.getPdffile(response);
      },
      error: (e) => {
        if (e) {
          alert(e);
        }
      },
      complete: () => { },
    });
  }

  getPdffile(data: any) {

    this.data =data
    const blob = new Blob([data], { type: 'image/jpeg' });
    const url = URL.createObjectURL(blob);
    this.src.push(url);

    // var blob = data as Blob
    // var url = window.URL.createObjectURL(blob)
    //window.open(url)
   setTimeout(() => this.applyInitialZoom(1.15), 100); // e.g. start at 200%
}

private applyInitialZoom(targetScale = 0.6) {
  if (!this.imageViewer || this.initialZoomApplied) return;

  const step = this.setting.zoomFactor ?? 0.1;

  if (targetScale < 1) {
    // need to zoom out
    const steps = Math.round((1 - targetScale) / step);

    let i = 0;
    const tick = () => {
      if (!this.imageViewer || i >= steps) return;
      try { this.imageViewer.zoomOut(); } catch {}
      i++;
      setTimeout(tick, 40);
    };
    tick();
  } else if (targetScale > 1) {
    // need to zoom in
    const steps = Math.round((targetScale - 1) / step);

    let i = 0;
    const tick = () => {
      if (!this.imageViewer || i >= steps) return;
      try { this.imageViewer.zoomIn(); } catch {}
      i++;
      setTimeout(tick, 40);
    };
    tick();
  }

  this.initialZoomApplied = true;
}

  downloadPDFFile() {
    const download = document.createElement('a');
    download.href = this.src;
    download.setAttribute('download', this.fileName);
    download.click();
  }

  printPdf() {
    const latestUrl = this.src[this.src.length - 1]; // use latest image
    const printWindow = window.open(latestUrl, '_blank');
    if (printWindow) {
      printWindow.onload = () => {
        printWindow.focus();
        printWindow.print();
      };
    } else {
      console.error('Popup blocked. Unable to print Image.');
    }
  }

  resetViewer() {
    if (this.imageViewer) {
      this.imageViewer.reset(); // This will reset zoom, pan, rotation, etc.
    }
  }

  handleEvent(event: any) {
    switch (event.name) {
      case 'download':
        this.downloadPDFFile();
        break;
      case 'print':
        this.printPdf();
        break;
      case 'reset':
        // Reset image viewer to original state (zoom, rotation, etc.)
        this.resetViewer();
        break;
    }
  }
}
